import posthog from "posthog-js";

// Only initialize PostHog if env vars exist and we're in production
const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (posthogKey && posthogHost && typeof window !== "undefined") {
  // Disable PostHog on localhost
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.endsWith(".localhost");

  // Only initialize on /v2 routes and not on localhost
  if (!isLocalhost) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      persistence: "localStorage+cookie",
      // Disable tracking by default - only track authenticated users
      // Call posthog.opt_in_capturing() after user authenticates
      opt_out_capturing_by_default: true,
      loaded: posthog => {
        // Debug mode in development
        if (process.env.NODE_ENV === "development") {
          posthog.debug();
        }
      },
    });
  }
}

export { posthog };
